import { FC, ReactNode, useEffect, useRef, useState } from 'react';
//
import { ListSubheaderStyle, navSubheaderLabelClass } from './style';

// ----------------------------------------------------------------------

interface NavSubheaderProps {
    isCollapse?: boolean;
    children: ReactNode;
}

const NavSubheader: FC<NavSubheaderProps> = ({ isCollapse, children }) => {
    const subheaderRef = useRef<HTMLLIElement>(null);

    const [isStuck, setIsStuck] = useState(false);

    // Sticky state is not exposed by CSS, so it is derived from the subheader
    // crossing the top edge of the scroll container.
    useEffect(() => {
        const subheader = subheaderRef.current;

        if (!subheader) {
            return undefined;
        }

        const observer = new IntersectionObserver(
            ([entry]) =>
                setIsStuck(
                    entry.intersectionRatio < 1 &&
                        entry.boundingClientRect.top <= (entry.rootBounds?.top ?? 0)
                ),
            {
                root: subheader.closest<HTMLElement>('.simplebar-content-wrapper'),
                threshold: [1],
            }
        );

        observer.observe(subheader);

        return () => observer.disconnect();
    }, []);

    return (
        <ListSubheaderStyle ref={subheaderRef} stuck={isStuck} isCollapse={!!isCollapse}>
            <span className={navSubheaderLabelClass}>{children}</span>
        </ListSubheaderStyle>
    );
};

export default NavSubheader;
